import { post, get } from '@/utils/axios';
import { isString } from 'lodash-es';
import useUserStore from '@/store/user';
import { ElMessage } from 'element-plus';

class User {
  static async login({ username, password }, showErrorMsg = true) {
    return await post(
      '/v1/sale/login',
      {
        username,
        password,
      },
      {
        showErrorMsg,
      },
    );
  }

  /**
   * 上報銷售在線狀態
   * @param {number|string} sale_id 銷售 id
   * @param {number} online 1 在線 / 0 離線
   */
  static async updateOnlineStatus({ sale_id, online = 1 }, showErrorMsg = true) {
    return await post(
      '/v2/teacher/update_online_status',
      {
        sale_id,
        online,
      },
      {
        showErrorMsg,
      },
    );
  }

  /**
   * 校驗賬號是否被凍結
   * @returns {Promise<unknown>}
   */
  static async checkAccountState() {
    const { userInfo } = useUserStore();
    if (!userInfo) return;

    const { id } = userInfo;

    try {
      await post('/v1/sale/login', {
        id,
      });
    } catch (e) {
      if (!e || !e.code) {
        ElMessage.error({
          message: '請刷新後重試',
          duration: 0,
        });
        return Promise.reject(e);
      }

      // 如果是凍結狀態，則清除所有緩存
      if (e.code === 401) {
        sessionStorage.clear();
        localStorage.clear();
        setTimeout(() => {
          location.reload();
        }, 1500);
      }

      return Promise.reject(e);
    }
  }

  static async setUserRemarks({ uid, remark, nickname_remark, token }) {
    const data = {
      uid,
    };

    if (isString(remark)) {
      data.remark = remark;
    }
    if (isString(nickname_remark)) {
      data.nickname_remark = nickname_remark;
    }

    return post('/api/user/teacher/set_user_mark', data, {
      headers: {
        Authorization: token,
        'yqw-token': token,
      },
    });
  }
}

export default User;
